module.exports = __webpack_public_path__ + "static/img/faq-reply-admin.b0f10e01.svg";